// import modular routes
import webRoutes from "./webroutes";
import enterPriseRoutes from "./enterpriseroutes";
import adminRoutes from "./adminroutes";
import marketPlaceRoutes from "./marketplaceroutes";

export default [...webRoutes, ...enterPriseRoutes, ...adminRoutes, ...marketPlaceRoutes];
